import axios from "axios";
import {saveAs} from "file-saver";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import * as API_URL from "../../constants/ApiUrl";
import * as QUERY from "../../constants/query/Inquiry.query";
import * as Routes from "../../constants/Routes";
import List from "../common/list/List";
import {InitialListProps, ListColumnType, ListProps} from "../common/list/List.props";
import Pagination from "../common/pagination/Pagination";
import Popup from "../common/popup/Popup";
import {PopupProps} from "../common/popup/Popup.props";
import * as INQUIRY_LIST_PROPS from "./constants/InquiryList.props";
import {InquiryDto} from "./dto/InquiryDto";
import {SearchDto} from "./dto/SearchDto";
import "./style.css";
import {InitialPaginationProps, PaginationProps} from "../common/pagination/Pagination.props";
import {InquirySearchFormProps} from "./constants/SearchForm.props";
import {Option} from "../common/searchForm/Option";
import SearchForm from "../common/searchForm/SearchForm";
import {InquiryType, InquiryTypeList, StatusType, StatusTypeList} from "./constants/SearchType";
import {SearchFormUtil} from "../common/searchForm/SearchFormUtil";

export default function Inquiry() {
    const navigate = useNavigate();

    const searchProps = InquirySearchFormProps;
    const [listProps, setListProps] = useState<ListProps<InquiryDto>>(InitialListProps);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [paginationProps, setPaginationProps] = useState<PaginationProps>(InitialPaginationProps);

    const [popupProps, setPopupProps] = useState<PopupProps | null>(null);

    useEffect(() => {
        setListProps({
            headers: [...INQUIRY_LIST_PROPS.HEADERS, {
                type: ListColumnType.BUTTON,
                name: "",
                key: "",
                button: {
                    name: "상세 보기",
                    onClick: (seq: number) => handleDetailButtonClick(seq)
                }
            }],
            items: [],
            emptyProps: {
                messageText: "문의 내역이 없습니다."
            },
            onCheckedChange: () => {}
        });

        setPaginationProps(prevState => ({
            ...prevState,
            onChange: (page: number) => {
                setPaginationProps(prevState => ({
                    ...prevState,
                    currentPage: page
                }));
            }
        }));

        searchProps.onSearch = () => getPage();
        searchProps.onUpdate = (options: Option[]) => {
            SearchFormUtil.setAllCheckboxesToTrue(options);
            searchProps.options = options;
        }
    }, []);

    useEffect(() => {
        getPage();
    }, [paginationProps.currentPage]);

    const getPage = () => {
        const selectedTypes: InquiryType[] = [];
        const selectedStatusTypes: StatusType[] = [];

        searchProps.options[0].value.forEach((status: boolean, index: number) => {
            if (status) {
                selectedTypes.push(InquiryTypeList[index].type);
            }
        });

        searchProps.options[1].value.forEach((status: boolean, index: number) => {
            if (status) {
                selectedStatusTypes.push(StatusTypeList[index].type);
            }
        });

        const searchDto: SearchDto = {
            page: paginationProps.currentPage,
            keyword: searchProps.options[2].value.text,
            keywordType: searchProps.options[2].value.type,
            types: selectedTypes,
            statusTypes: selectedStatusTypes
        }

        axios.post(API_URL.GRAPHQL, {query: QUERY.GET_INQUIRIES(searchDto)})
            .then(response => {
                const paginationDto = response.data.data.getInquiries;

                setTotalCount(paginationDto.totalItems);
                setPaginationProps(prevState => ({
                    ...prevState,
                    currentPage: paginationDto.currentPage,
                    totalPage: paginationDto.totalPage
                }));
                setListProps(prevState => ({
                    ...prevState,
                    items: paginationDto.items
                }));
            });
    }

    const handleDetailButtonClick = (inquirySeq: number) => {
        navigate(Routes.INQUIRY_DETAIL, {state: {seq: inquirySeq}});
    }

    const handleSaveAllButtonClick = () => {
        axios.post(API_URL.EXPORT_INQUIRIES_TO_EXCEL, [], {responseType: "blob"})
            .then(response => {
                saveAs(response.data, "문의 목록.xlsx");
            });
    }

    const handleSaveButtonClick = () => {
        const seqs = listProps.items.filter(item => item.checked).map(item => item.seq);

        if (seqs.length === 0) {
            setPopupProps({
                subject: "문의 사항 엑셀 저장",
                message1: "저장할 항목을 선택해 주세요.",
                message2: null,
                buttonName: "확인",
                onConfirm: () => setPopupProps(null),
                useCloseButton: false,
                onClose: () => {}
            });

            return
        }

        axios.post(API_URL.EXPORT_INQUIRIES_TO_EXCEL, seqs, {responseType: "blob"})
            .then(response => {
                saveAs(response.data, "문의 목록.xlsx");
            });
    }

    return (
        <>
            <div className="inquiry-management">
                <main className="wrapper">
                    <div className="inquiry-body">
                        <section className="list-search-section">
                            <div className="title">
                                문의 관리
                            </div>
                            <SearchForm {...searchProps}/>
                        </section>
                        <div className="inquiry-numbers">
                            <div className="inquiry-wrapper">
                                <div className="inquiry-all-number" data-testid="totalItems">
                                    전체 문의 개수 {totalCount}개
                                </div>
                                <div className="inquiry-choice">
                                    <button className="all" data-testid="saveAllButton" onClick={handleSaveAllButtonClick}>
                                        전체 엑셀저장
                                    </button>
                                    <button className="save" onClick={handleSaveButtonClick}>
                                        선택항목 엑셀저장
                                    </button>
                                </div>
                            </div>
                            <List {...listProps}/>
                        </div>
                        <Pagination {...paginationProps}/>
                    </div>
                </main>
            </div>
            {popupProps && <Popup data={popupProps}/>}
        </>
    );
}